export default "__VITE_ASSET__DBj7A$ew__"